import React, {useContext, useState, useEffect} from 'react';
import './AppWindow.scss';
import {I18nContext} from '../contexts/i18nContext';
import {NotificationsContext} from '../contexts/notificationsContext';
import MainWindow from './MainWindow';
import Header from './Header';
import Menu from './Menu';
import {Modal} from "../components/_common";
import FeedbackForm from '../components/feedback/FeedbackForm';
import Notifications from '../components/notifications/Notifications';

const AppWindow = () => {
  const { t } = useContext(I18nContext);
  const { getNotifications, isNotificationUnread, markNotificationsAsRead } = useContext(NotificationsContext);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  useEffect(() => {
    getNotifications();
    setInterval(() => {
      getNotifications();
    }, 2 * 60 * 1000)
  }, []);

  const toggleNotifications = () => {
    if (showNotifications) {
      markNotificationsAsRead();
    }
    setShowNotifications(!showNotifications);
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const toggleFeedbackModal = () => {
    setShowFeedbackModal(!showFeedbackModal);
    setShowMenu(false);
  };

  return (
    <div className='AppWindow'>
      <Header
        toggleMenu={toggleMenu}
        toggleNotifications={toggleNotifications}
        isNotificationUnread={isNotificationUnread}
      />
      <MainWindow />
      <div className={showMenu ? 'menuBackgroundBlurActive' : 'menuBackgroundBlur'} />
      <Menu showMenu={showMenu} close={toggleMenu} toggleFeedbackModal={toggleFeedbackModal} />

      {!!showFeedbackModal && (
        <Modal
          closeModal={toggleFeedbackModal}
          title={t('add feedback')}
          width='310px'
        >
          <FeedbackForm
            secondaryButtonAction={toggleFeedbackModal}
          />
        </Modal>
      )}

      {!!showNotifications && (
        <Modal
          closeModal={toggleNotifications}
          title={t('notifications')}
          width='340px'
        >
          <Notifications />
        </Modal>
      )}
    </div>
  )
};

export default AppWindow;
